import React, { useState } from 'react'
import ModalListaEmpresaMP from './ModalListaEmpresaMP'
import ModalListaSeleccionCuentasVigenciaMP from './ModalListaSeleccionCuentasVigenciaMP'
import { postInsertarEnMaestrosProcedimientosDos } from '../../../services/Contratacion'

const ModalProcedimientosNoOperacionalesMP = ({setmodalOnProcedimientosNoOperaciones, dataUnMaestroProcedimiento,setactualizarDataProcedimientosNoOperacionales}) => {
    const [modalOnListaEmpresa, setmodalOnListaEmpresa]=useState(false)
    const [modalOnListaSeleccionCuentasVigencia, setmodalOnListaSeleccionCuentasVigencia]=useState(false)
    const [errorCodigoEmpresa, seterrorCodigoEmpresa]=useState('Seleccionar Codigo')
    const [errorVigencia, seterrorVigencia]=useState('Seleccionar vigencia')
    const [errorCuentaContable, seterrorCuentaContable]=useState('Seleccionar cuenta contable')
    const [dataCuentaContable, setdataCuentaContable]=useState('')
    const [dataEmpresa, setdataEmpresa]=useState({
      "EMPCOD":'',
      "EmpRazSoc":''
    })
    const handleCancelarClick=()=>{
      setmodalOnProcedimientosNoOperaciones(false)
    }

    const handleOnclickListaEmpresa=()=>{
      setmodalOnListaEmpresa(true)
    }

    const handleOnclickListaSeleccionCuentasVigencia=()=>{
        setmodalOnListaSeleccionCuentasVigencia(true)
    }

    const passDataCuentaContable=(data)=>{
      seterrorCuentaContable('')
      setdataCuentaContable(data.CntCod)
      setmodalOnListaSeleccionCuentasVigencia(false)
  }

  const passDataEmpresa=(data)=>{
    seterrorCodigoEmpresa('')
    setmodalOnListaEmpresa(false)    
    setdataEmpresa({
      "EMPCOD": data.EMPCOD,
      "EmpRazSoc":data.EmpRazSoc
    })
  }

  const handleSubmitGuardar=(e)=>{
    e.preventDefault()
    const insert={
      'PrcCtaVig': e.target.vigencia.value,
      'PrcEmpCta': e.target.codigoEmpresa.value,
      'PrcCtaGru': e.target.cuentaContable.value,
      'PRCODI': dataUnMaestroProcedimiento.PRCODI
    }
    if(!errorCodigoEmpresa && !errorVigencia && !errorCuentaContable){
      postInsertarEnMaestrosProcedimientosDos(insert).then((res)=>{
        setactualizarDataProcedimientosNoOperacionales(insert)
        setmodalOnProcedimientosNoOperaciones(false)
      })
    }
    
    
  }

  const handleChangeVigencia=(e)=>{
    if(e.target.value){
      seterrorVigencia('')
    }else{
      seterrorVigencia('Seleccionar vigencia')
    }
  }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
       <div className="sm:h-[calc(100%)] max-w-7xl   mx-auto relative w-auto pointer-events-none ">
        <div className=" max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Crear Procedimientos No Operacionales
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X
            </button>
          </div>
          <div className="flex-auto overflow-y-auto relative px-2">
            <form onSubmit={handleSubmitGuardar}>
              <div className="flex py-2 text-left">
                <div className="w-1/3">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código
                  </label>
                  <input
                    //onChange={handleOnchangeCodigo} 
                    defaultValue={dataUnMaestroProcedimiento.PRCODI}
                    disabled={true}             
                    type="text"
                    name="codigo"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                      {/* {errorCodigo} */}
                    </label>
                  </div>
                  <div className="w-2/3 ml-2">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción
                  </label>
                  <textarea
                    //onChange={handleOnchangeDescripcion} 
                    defaultValue={dataUnMaestroProcedimiento.PrNomb}  
                    disabled={true}             
                    type="text"
                    name="descripcion"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {/* {errorDescripcion} */}
                  </label>
                  </div>
                  
              </div>
              
              
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Codigo
                    </label>
                    <input
                    defaultValue={dataEmpresa.EMPCOD}
                    onFocus={handleOnclickListaEmpresa}              
                    type="text"
                    name="codigoEmpresa"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCodigoEmpresa}
                  </label>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Empresa
                    </label>
                    <input
                    defaultValue={dataEmpresa.EmpRazSoc}  
                    disabled={true}           
                    type="text"
                    name="empresa"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                    </div>
                </div>
                <div className="flex py-2 text-left">
                  <div className="w-1/2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Vigencia
                    </label>
                    <input
                    onChange={handleChangeVigencia}              
                    type="number"
                    name="vigencia"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorVigencia}
                  </label>
                    </div>
                    <div className="w-1/2 ml-2">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Cuenta Contable
                    </label>
                    <input
                    defaultValue={dataCuentaContable}
                    onFocus={handleOnclickListaSeleccionCuentasVigencia}            
                    type="text"
                    name="cuentaContable"
                    autoComplete="off"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-gray bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                    {errorCuentaContable}
                  </label>
                    </div>
                </div>
                
                
                
                
                
                
                
                
                <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button type="submit"
              className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
              Guardar
            </button>
          </div>
                
            </form>
            
          </div>
          
        </div>
      </div>
      
      {modalOnListaSeleccionCuentasVigencia? <ModalListaSeleccionCuentasVigenciaMP setmodalOnListaSeleccionCuentasVigencia={setmodalOnListaSeleccionCuentasVigencia} passDataCuentaContable={passDataCuentaContable}/>:null}
      {modalOnListaEmpresa? <ModalListaEmpresaMP setmodalOnListaEmpresa={setmodalOnListaEmpresa} passDataEmpresa={passDataEmpresa}/>: null}
    </div>
  )
}

export default ModalProcedimientosNoOperacionalesMP